document.addEventListener("DOMContentLoaded", function () {

  const images = document.querySelectorAll('.product-media__image');

  images.forEach(function(img){

    const container = img.parentElement;

    container.style.overflow = "hidden";
    container.style.cursor = "zoom-in";

    container.addEventListener("mousemove", function(e){

      const rect = container.getBoundingClientRect();

      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;

      img.style.transformOrigin = x + "% " + y + "%";
      img.style.transform = "scale(2)";

    });

    container.addEventListener("mouseleave", function(){

      img.style.transform = "scale(1)";
      img.style.transformOrigin = "center";

    });

  });

});